<template>
  <Tab
    :values="[
      { name: 'Urbana', slot: 'urbana' },
      { name: 'Rural', slot: 'rural' },
    ]"
    @tabchange="forceRerenderTab"
    ref="tab"
  >
    <template v-slot:urbana>
      <div style="display: flex">
        <h4>Dispositivos</h4>
        <div style="margin-left: auto">
          <LoadButton
            style="flex; margin-bottom: 25px; background-color: #006035;"
            ref="btn_gerar"
            @click="abrirModalAplicativo"
            class="btn btn-success"
            text="+"
            loadtext="Adicionando"
          >
          </LoadButton>
        </div>
      </div>
      <Datatable
        v-if="tabComponent"
        ref="datatable"
        :fields="fieldsAplicacao"
        :fieldsMobile="fieldsMobile"
        :url="'/Devices/ReadDeviceUrban'"
        @edit="form.crud.edit($event)"
        :where="where"
        :share="abrirModalCompartilhar"
        :mobileCardMode="true"
      >
        <template v-slot:status="data">
          <div style="text-align: center" v-if="data.row.status == 1">
            <img src="../../../public/img/pending.svg" alt="Pendente" />
          </div>
          <div style="text-align: center" v-if="data.row.status == 2">
            <img src="../../../public/img/offline.svg" alt="Offline" />
          </div>
          <div style="text-align: center" v-if="data.row.status == 3">
            <img src="../../../public/img/ok.svg" alt="Online" />
          </div>
        </template>
        <template v-slot:acoes="data">
          <div v-if="data.row.status == 1">
            <button
              @click="abrirModalFinalizar(data.row.id)"
              style="
                width: 100%;
                height: 100%;
                padding: 10px;
                background: #006035;
                border-radius: 5px;
                justify-content: center;
                align-items: center;
                gap: 5px;
                display: inline-flex;
              "
            >
              <div
                style="
                  text-align: center;
                  color: white;
                  font-size: 16px;
                  font-weight: 700;
                  word-wrap: break-word;
                "
              >
                Finalizar Cadastro
              </div>
            </button>
          </div>
          <div v-else>
            <!-- Desktop: apenas ícones -->
            <div
              v-if="!isMobile()"
              class="text-center"
              style="display: flex; justify-content: center; gap: 1rem"
            >
              <div class="text-center">
                <button
                  class="btn btn-white p-0"
                  @click="$emit(form.crud.edit(data.row))"
                >
                  <i class="bx bx-edit-alt text-primary"></i>
                </button>
              </div>
              <div class="text-center">
                <button
                  class="btn btn-white p-0"
                  @click="abrirModalCompartilhar(data.row.id)"
                >
                  <i class="bx bx-share-alt text-success"></i>
                </button>
              </div>
            </div>

            <!-- Mobile: ícones + texto -->
            <div v-else class="action-buttons-mobile">
              <button
                class="btn btn-outline-primary btn-mobile-action"
                @click="$emit(form.crud.edit(data.row))"
              >
                <i class="bx bx-edit-alt me-2"></i>
                Editar
              </button>
              <button
                class="btn btn-outline-success btn-mobile-action"
                @click="abrirModalCompartilhar(data.row.id)"
              >
                <i class="bx bx-share-alt me-2"></i>
                Compartilhar
              </button>
            </div>
          </div>
        </template>
      </Datatable>
    </template>

    <template v-slot:rural>
      <div style="display: flex">
        <h4>Dispositivos</h4>
        <div style="margin-left: auto">
          <LoadButton
            style="margin-bottom: 25px; background-color: #006035; "
            ref="btn_gerar"
            @click="abrirModalAplicativo"
            @edit="form.crud.edit($event)"
            class="btn btn-success"
            text="+"
            loadtext="Adicionando"
          >
          </LoadButton>
        </div>
      </div>

      <Datatable
        v-if="tabComponent"
        ref="datatable"
        :fields="fieldsAplicacao"
        :fieldsMobile="fieldsMobile"
        :url="'/Devices/ReadDeviceRural'"
        @edit="form.crud.edit($event)"
        :where="where"
        :mobileCardMode="true"
      >
        <template v-slot:status="data">
          <div v-if="data.row.status == 1">
            <img src="../../../public/img/pending.svg" alt="Pendente" />
          </div>
          <div v-if="data.row.status == 2">
            <img src="../../../public/img/offline.svg" alt="Offline" />
          </div>
          <div v-if="data.row.status == 3">
            <img src="../../../public/img/ok.svg" alt="Online" />
          </div>
        </template>
        <template v-slot:acoes="data">
          <div v-if="data.row.status == 1">
            <button
              @click="abrirModalFinalizar(data.row.id)"
              style="
                width: 100%;
                height: 100%;
                padding: 10px;
                background: #006035;
                border-radius: 5px;
                justify-content: center;
                align-items: center;
                gap: 5px;
                display: inline-flex;
              "
            >
              <div
                style="
                  text-align: center;
                  color: white;
                  font-size: 16px;
                  font-weight: 700;
                  word-wrap: break-word;
                "
              >
                Finalizar Cadastro
              </div>
            </button>
          </div>
          <div v-else>
            <!-- Desktop: apenas ícones -->
            <div
              v-if="!isMobile()"
              class="text-center"
              style="display: flex; justify-content: center; gap: 1rem"
            >
              <div class="text-center">
                <button
                  class="btn btn-white p-0"
                  @click="$emit(form.crud.edit(data.row))"
                >
                  <i class="bx bx-edit-alt text-primary"></i>
                </button>
              </div>
              <div class="text-center">
                <button
                  class="btn btn-white p-0"
                  @click="abrirModalCompartilhar(data.row.id)"
                >
                  <i class="bx bx-share-alt text-success"></i>
                </button>
              </div>
            </div>

            <!-- Mobile: ícones + texto -->
            <div v-else class="action-buttons-mobile">
              <button
                class="btn btn-outline-primary btn-mobile-action"
                @click="$emit(form.crud.edit(data.row))"
              >
                <i class="bx bx-edit-alt me-2"></i>
                Editar
              </button>
              <button
                class="btn btn-outline-success btn-mobile-action"
                @click="abrirModalCompartilhar(data.row.id)"
              >
                <i class="bx bx-share-alt me-2"></i>
                Compartilhar
              </button>
            </div>
          </div>
        </template>
      </Datatable>
    </template>
  </Tab>

  <div class="modal fade" tabindex="-1" ref="modal_aplicativo">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header bg-primary">
          <h3 class="modal-title text-white mb-2">Adicionar Dispositivo</h3>
          <button
            type="button"
            class="btn-close"
            @click="fecharModalAplicativo"
          ></button>
        </div>
        <div class="modal-body">
          <span style="white-space: pre-line">
            Para adicionar um dispositivo você precisa cadastrar no sistema
            através do app onAgro, no seu celular.
          </span>
        </div>
        <hr />
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
  <div class="modal fade" tabindex="-1" ref="modal_finalizar">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header bg-primary">
          <h3 class="modal-title text-white mb-2">Finalizar Cadastro</h3>
          <button
            type="button"
            class="btn-close"
            @click="fecharModalFinalizar"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="mb-6 col-md-6 col-12">
              <input
                type="radio"
                name="propriedade"
                value="Urbano"
                checked
                v-model="this.finalize.tipo"
              />
              Urbano

              <input
                type="radio"
                name="propriedade"
                value="Rural"
                v-model="this.finalize.tipo"
              />
              Rural
            </div>
          </div>
          <div class="row">
            <div class="mb-6 col-md-6 col-12">
              <label class="form-label">Nome do Dispositivo<span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                v-model="this.finalize.nome"
              />
            </div>
            <div class="mb-6 col-md-6 col-12">
              <label class="form-label"
                >Propriedade<span class="text-danger">*</span></label
              >
              <SelectData
                v-if="this.finalize.tipo == 'Urbano'"
                :key="`urban-${finalizarModalKey}`"
                url="/Devices/PropertiesUrban"
                field="id"
                label="nome"
                empty="Selecione"
                :value="
                  this.finalize.propriedades == undefined
                    ? null
                    : this.finalize.propriedades
                "
                @value="this.finalize.propriedades = $event"
              >
              </SelectData>
              <SelectData
                v-else
                :key="`rural-${finalizarModalKey}`"
                url="/Devices/PropertiesRural"
                field="id"
                label="nome"
                empty="Selecione"
                :value="
                  this.finalize.propriedades == undefined
                    ? null
                    : this.finalize.propriedades
                "
                @value="this.finalize.propriedades = $event"
              >
              </SelectData>
            </div>
            <div class="mb-6 col-md-6 col-12" v-if="this.finalize.propriedades">
              <label class="form-label"
                >Pin de Localização<span class="text-danger">*</span></label
              >
              <!-- Custom Dropdown -->
              <div class="custom-pin-select" ref="pinDropdown" @click="loadPropertyLocations">
                <div
                  class="custom-pin-select-trigger"
                  @click="togglePinDropdown"
                  :class="{ 'is-open': isPinDropdownOpen }"
                >
                  <span v-if="!finalize.localId || finalize.localId === null" class="pin-placeholder">
                    Selecione o pin
                  </span>
                  <span v-else class="selected-option">
                    <span
                      class="color-badge"
                      :style="{ backgroundColor: getSelectedPinColor() }"
                    ></span>
                    {{ getSelectedPinText() }}
                  </span>
                  <i class="bx bx-chevron-down dropdown-icon"></i>
                </div>

                <div v-if="isPinDropdownOpen" class="custom-pin-select-dropdown">
                  <div
                    class="custom-pin-select-option"
                    @click="selectPin(null)"
                  >
                    Selecione o pin
                  </div>
                  <div
                    v-for="location in propertyLocations"
                    :key="location.id"
                    class="custom-pin-select-option"
                    :class="{ 'is-selected': finalize.localId === location.id }"
                    @click="selectPin(location.id)"
                  >
                    <span
                      class="color-badge"
                      :style="{ backgroundColor: location.cor || '#6c757d' }"
                    ></span>
                    <span class="option-text">
                      {{ location.nome || 'Pin sem nome' }}
                      {{ location.principal ? '(Principal)' : '' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <input :value="(this.finalize.id = id)" type="hidden" />
          </div>
        </div>
        <hr />
        <div class="modal-footer">
          <LoadButton
            style="flex; margin-bottom: 25px; margin-left: 25px; background: #006035;"
            @click="FinalizarCadastro()"
            ref="btn_finalizar"
            class="btn btn-success"
            text="Finalizar"
            loadtext="Finalizando..."
          >
          </LoadButton>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de Compartilhamento -->
  <ShareDeviceModal 
    ref="shareModal"
    :deviceId="currentDeviceId"
    @user-shared="onUserShared"
    @user-removed="onUserRemoved"
    @closed="onModalClosed"
  />
  <Alert ref="alert"></Alert>
</template>

<script>
import Datatable from "../../components/crud/Datatable.vue";
import Tab from "../../components/form/Tab.vue";
import LoadButton from "../../components/form/LoadButton.vue";
import SelectData from "../../components/crud/input/SelectData.vue";
import Alert from "../../components/Alert.vue";
import ShareDeviceModal from "../modal/ShareDeviceModal.vue";

export default {
  props: ["form"],
  components: {
    Tab,
    Datatable,
    LoadButton,
    SelectData,
    Alert,
    ShareDeviceModal,
  },

  data() {
    return {
      tabComponent: true,
      status: null,
      currentDeviceId: null,
      propertyLocations: [],
      isPinDropdownOpen: false,
      finalizarModalKey: 0,
      finalize: {
        id: null,
        tipo: "Urbano",
        nome: null,
        propriedades: null,
        localId: null,
      },
      where: {
        nome: {
          operator: "LIKE",
          replace: "%{value}%",
        },
      },
      fields: [
        { name: "Nome", value: "nome", style: { width: "100px" } },
        {
          name: "Endereço",
          value: "logradouro",
          style: { textAlign: "center" },
        },
        {
          name: "Ação",
          type: "action",
          orderby: false,
          value: "status",
          edit: true,
          delete: false,
          style: { width: "100px", minWidth: "100px", textAlign: "center" },
        },
      ],

      fieldsAplicacao: [
        { name: "Status", value: "status", type: "slot", orderby: false, style: { width: "70px" } },
        { name: "Nome", value: "nome" },
        { name: "QRCode", value: "qrcode" },
        {
          name: "Data Vinculação",
          value: "dataVinculacao",
          format: (v, d) => {
            if (v != null) {
              return new Date(v).toLocaleString('pt-BR');
            } else {
              return "-";
            }
          },
        },
        { name: "Ações", value: "acoes", type: "slot", orderby: false },
      ],
      fieldsMobile: [
        { name: "Status", value: "status", type: "slot", style: { width: "70px" } },
        { name: "Nome / QRCode / Data Vinculação", value: ["nome", "qrcode", "dataVinculacao"] },
        { name: "Ações", value: "acoes", type: "slot" },
      ],
    };
  },

  watch: {
    'finalize.tipo': function(newVal, oldVal) {
      // Quando muda o tipo (Urbano/Rural), resetar propriedade e pin
      if (newVal !== oldVal) {
        this.finalize.propriedades = null;
        this.finalize.localId = null;
        this.propertyLocations = [];
      }
    },
    'finalize.propriedades': function(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.loadPropertyLocations();
      } else if (!newVal) {
        this.propertyLocations = [];
        this.finalize.localId = null;
      }
    }
  },

  mounted() {
    // Fechar dropdown ao clicar fora
    document.addEventListener('click', (e) => {
      const dropdown = this.$refs.pinDropdown;
      if (dropdown && !dropdown.contains(e.target)) {
        this.isPinDropdownOpen = false;
      }
    });
  },

  methods: {
    async loadPropertyLocations() {
      if (!this.finalize.propriedades) {
        this.propertyLocations = [];
        return;
      }

      try {
        const response = await this.urlGet(`/Devices/PropertyLocations/${this.finalize.propriedades}?available=true`);
        this.propertyLocations = response.data.locations || [];

        // Auto-selecionar o pin principal se existir
        const principalLocation = this.propertyLocations.find(l => l.principal);
        if (principalLocation && !this.finalize.localId) {
          this.finalize.localId = principalLocation.id;
        }
      } catch (error) {
        console.error('Erro ao carregar locais da propriedade:', error);
        this.propertyLocations = [];
      }
    },

    FinalizarCadastro() {
      if (!this.finalize.localId) {
        this.$refs.alert.show(
          "Atenção",
          "Selecione um pin de localização para o dispositivo!",
          null,
          5000,
          "bg-warning"
        );
        return;
      }

      this.urlPost("/Devices/FinalizeRegistration", this.finalize)
        .then((e) => {
          this.error = null;
          this.$refs.alert.show(
            "Finalizando",
            "Cadastro Finalizado com sucesso!",
            null,
            5000,
            "bg-primary"
          );
          setTimeout(() => {
            this.finalize.nome = null;
            this.finalize.propriedades = null;
            this.finalize.localId = null;
            this.propertyLocations = [];
            this.fecharModalFinalizar();
            this.forceRerenderTab();
          }, 1000);
        })
        .catch((e) => {
          if (e.response.status == 400) {
            this.error = e.response.data;
            this.$refs.alert.show(
              "Erro ",
              "Erro no processo",
              null,
              3000,
              "bg-danger"
            );
          } else {
            this.$refs.alert.show(
              "Erro " + e.response.status,
              "Não foi possível finalizar o cadastro!",
              null,
              3000,
              "bg-danger"
            );
          }
        });
    },
    forceRerenderTab() {
      this.tabComponent = false;
      this.$nextTick(() => {
        this.tabComponent = true;
      });
    },
    oncreate(form) {
      if (form.expire == 0) {
        form.expire = null;
        return;
      }
      var expire = new Date();
      expire.setDate(expire.getDate() + form.expire);
      form.expire = expire;
    },
    abrirModalAplicativo() {
      $(this.$refs.modal_aplicativo).modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    fecharModalAplicativo() {
      $(this.$refs.modal_aplicativo).modal("hide");
    },
    abrirModalFinalizar(data) {
      this.finalize.nome = null;
      this.finalize.propriedades = null;
      this.finalize.localId = null;
      this.propertyLocations = [];
      this.finalizarModalKey++;
      $(this.$refs.modal_finalizar).modal({
        backdrop: "static",
        keyboard: false,
      });
      this.id = data;
    },
    fecharModalFinalizar() {
      $(this.$refs.modal_finalizar).modal("hide");
    },
    abrirModalCompartilhar(id) {
      this.currentDeviceId = id;
      this.$refs.shareModal.open(id);
    },
    
    // Eventos do ShareDeviceModal
    onUserShared(data) {
      this.forceRerenderTab();
    },
    onUserRemoved(data) {
      this.forceRerenderTab();
    },
    onModalClosed() {
      this.currentDeviceId = null;
    },
    isMobile() {
      return window.innerWidth < 768;
    },

    // Métodos para o dropdown customizado de pins
    togglePinDropdown() {
      this.isPinDropdownOpen = !this.isPinDropdownOpen;
    },
    selectPin(pinId) {
      this.finalize.localId = pinId;
      this.isPinDropdownOpen = false;
    },
    getSelectedPinColor() {
      const selected = this.propertyLocations.find(l => l.id === this.finalize.localId);
      return selected?.cor || '#6c757d';
    },
    getSelectedPinText() {
      const selected = this.propertyLocations.find(l => l.id === this.finalize.localId);
      if (!selected) return '';
      return `${selected.nome || 'Pin sem nome'} ${selected.principal ? '(Principal)' : ''}`;
    },
  },
};
</script>

<style scoped>
/* Custom Pin Select Dropdown */
.custom-pin-select {
  position: relative;
  width: 100%;
}

.custom-pin-select-trigger {
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  min-height: 38px;
  position: relative;
}

.custom-pin-select-trigger:hover {
  border-color: #86b7fe;
}

.custom-pin-select-trigger.is-open {
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.custom-pin-select-trigger .pin-placeholder {
  color: #6c757d;
}

.custom-pin-select-trigger .dropdown-icon {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.2rem;
  transition: transform 0.2s;
}

.custom-pin-select-trigger.is-open .dropdown-icon {
  transform: translateY(-50%) rotate(180deg);
}

.custom-pin-select-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-height: 250px;
  overflow-y: auto;
  z-index: 1050;
}

.custom-pin-select-option {
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: background-color 0.15s;
}

.custom-pin-select-option:hover {
  background-color: #f8f9fa;
}

.custom-pin-select-option.is-selected {
  background-color: #e7f3ff;
  font-weight: 500;
}

.color-badge {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  flex-shrink: 0;
}

.selected-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.option-text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

